import React from 'react';
import MembershipInvoicesDatatable from '../MembershipInvoicesDatatable';
import { useMembershipShowContext } from '../../startup/MembershipShowApp';

export default function InvoiceHistory() {
  const { membership, invoicesDatatablePath } = useMembershipShowContext();
  if (!invoicesDatatablePath) return null;

  return (
    <div className="team-member-card mb-3">
      <div className="team-member-card-header">
        <div className="team-member-card-header-left">
          <div className="team-member-card-title-row">
            <h2 className="team-member-card-title">Invoices</h2>
          </div>
        </div>
      </div>
      <div className="team-member-card-body">
        <MembershipInvoicesDatatable
          datatablePath={invoicesDatatablePath}
          membershipId={membership.id}
          showMemberColumn={false}
        />
      </div>
    </div>
  );
}
